import createIcon from '../../createIcon';

/**
 * @component @name OpenWith
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgOUgxNFY2SDE3TDEyIDFMNyA2SDEwVjlaTTkgMTBINlY3TDEgMTJMNiAxN1YxNEg5VjEwWk0yMyAxMkwxOCA3VjEwSDE1VjE0SDE4VjE3TDIzIDEyWk0xNCAxNUgxMFYxOEg3TDEyIDIzTDE3IDE4SDE0VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OpenWith = createIcon('OpenWith', [
  [
    'path',
    {
      d: 'M10 9H14V6H17L12 1L7 6H10V9ZM9 10H6V7L1 12L6 17V14H9V10ZM23 12L18 7V10H15V14H18V17L23 12ZM14 15H10V18H7L12 23L17 18H14V15Z',
      key: 'kbpajr',
    },
  ],
]);

export default OpenWith;
